/**
 * Navigation functionality
 */

export function initMobileMenu() {
    const menuToggle = document.querySelector('.menu-toggle');
    const navigation = document.querySelector('#site-navigation');

    if (!menuToggle || !navigation) {
        return;
    }

    menuToggle.addEventListener('click', () => {
        const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', !expanded);
        navigation.classList.toggle('toggled');
    });

    // Close menu when clicking outside
    document.addEventListener('click', (event) => {
        const isClickInside = navigation.contains(event.target);

        if (!isClickInside && navigation.classList.contains('toggled')) {
            menuToggle.setAttribute('aria-expanded', 'false');
            navigation.classList.remove('toggled');
        }
    });

    // Close menu on escape key
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && navigation.classList.contains('toggled')) {
            menuToggle.setAttribute('aria-expanded', 'false');
            navigation.classList.remove('toggled');
            menuToggle.focus();
        }
    });
}
